export const TEXT = 'TEXT'
export const EMAIL = 'EMAIL'
export const TEXT_AREA = 'TEXT_AREA'
export const SELECT = 'SELECT'
export const CHECKBOXES = 'CHECKBOXES'
export const RADIOS = 'RADIOS'
export const FILE = 'FILE'
export const NUMBER = 'NUMBER'
export const PHONE = 'PHONE' // tu walidacja czy są same cyfry ,+
export const CAPATCHA = 'CAPATCHA' // tu walidacja google capatcha
export const DATE = 'DATE'
